// Till-currency formatting for the Fashion layout. Follows the business unit's
// first currency: its price precision and whether the symbol sits after the
// amount (symbolRightSide === "Y"), as SMCartSummary does. Rupee amounts use
// Indian digit grouping (1,23,456.00), and a negative amount carries its sign
// in front of the symbol (−₹1,234.00) so callers never add their own minus.
const MINUS = "−";

export function formatMoney(value, tillData) {
  const currency = tillData?.tillAccess?.csBunit?.currencies?.[0] || {};
  const precision = currency.prcPrecision ?? 2;
  const symbol = currency.currSymbol || "";
  const n = Number(value) || 0;
  const locale = currency.isoCode === "INR" || symbol === "₹" ? "en-IN" : undefined;
  const amount = Math.abs(n).toLocaleString(locale, { minimumFractionDigits: precision, maximumFractionDigits: precision });
  const sign = n < 0 && Number(amount.replace(/[^0-9]/g, "")) !== 0 ? MINUS : "";
  return currency.symbolRightSide === "Y" ? `${sign}${amount} ${symbol}`.trim() : `${sign}${symbol}${amount}`;
}
